import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import SignUp from './views/non-auth/SignUp.vue';
import SignIn from './views/non-auth/SignIn.vue';
import SignOut from './views/non-auth/SignOut.vue';
import RestorePassword from './views/non-auth/RestorePassword.vue';
import EmailConfirm from './views/non-auth/EmailConfirm.vue';
import Dashboard from './views/non-auth/Dashboard.vue';
import AccessDenied from './views/non-auth/AccessDenied.vue';
import PageNotFound from './views/non-auth/PageNotFound.vue';
import UserRegistered from './views/non-auth/UserRegistered.vue';
import CreateNewPassword from "./views/non-auth/CreateNewPassword.vue";
import PasswordChanged from "./views/non-auth/PasswordChanged.vue";
import HomePage from "./views/non-auth/HomePage.vue";
import Health from "./views/non-auth/Health.vue";
import LegalDocument from "./views/legal/LegalDocument.vue";
import ProjectForm from "@/views/dashboard/ProjectForm.vue";
import Projects from "@/views/dashboard/Projects.vue";
import Telegram from "@/views/dashboard/Telegram.vue";
import TestRoles from "@/views/dashboard/TestRoles.vue";
import TestNavigation from "@/views/dashboard/TestNavigation.vue";
import TestRouteGuards from "@/views/dashboard/TestRouteGuards.vue";
import TestPermissions from "@/views/dashboard/TestPermissions.vue";

// Admin components
import DzenSources from "@/views/admin/DzenSources.vue";
import Websites from "@/views/admin/Websites.vue";
import AdminX from "@/views/dashboard/AdminX.vue";
import UserManagement from "@/views/admin/UserManagement.vue";
import LlmCosts from "@/views/admin/LlmCosts.vue";
import AuthEvents from "@/views/admin/AuthEvents.vue";
import Plans from "@/views/admin/Plans.vue";
import SystemMonitoring from "@/views/admin/SystemMonitoring.vue";
import SourceConfiguration from "@/views/admin/SourceConfiguration.vue";
import InvitationCodes from "@/views/admin/InvitationCodes.vue";
import Settings from "@/views/admin/Settings.vue";
import ReferenceManagement from "@/views/admin/references/ReferenceManagement.vue";
import AuthorsManagement from "@/views/admin/AuthorsManagement.vue";
import PromptsManagement from "@/views/admin/PromptsManagement.vue";
import SocialAccounts from "@/views/admin/SocialAccounts.vue";
import ProxiesManagement from "@/views/admin/ProxiesManagement.vue";
import RolesPermissions from "@/views/admin/RolesPermissions.vue";

// Profile components
import Profile from "@/views/profile/Profile.vue";

// Monitoring components
import Messages from "@/views/monitoring/Messages.vue";
import Entities from "@/views/monitoring/Entities.vue";
import Reports from "@/views/monitoring/Reports.vue";
import MySources from "@/views/monitoring/MySources.vue";
import Networks from "@/views/monitoring/Networks.vue";

// Notification components
import NotificationSettings from "@/views/notifications/NotificationSettings.vue";

const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode
  routes: [
    {
      path: '/',
      component: HomePage,
      meta: {requiresAuth: false, title: 'Следограф'},
      name: 'home',
    },
    // Юридические тексты: доступны без входа
    {
      path: '/privacy',
      component: LegalDocument,
      props: { doc: 'privacy' },
      meta: {requiresAuth: false, title: 'Политика обработки персональных данных / Следограф'},
    },
    {
      path: '/terms',
      component: LegalDocument,
      props: { doc: 'terms' },
      meta: {requiresAuth: false, title: 'Условия использования / Следограф'},
    },
    {
      path: '/requisites',
      component: LegalDocument,
      props: { doc: 'requisites' },
      meta: {requiresAuth: false, title: 'Реквизиты и контакты / Следограф'},
    },
    {
      path: '/consent/account',
      component: LegalDocument,
      props: { doc: 'consentAccount' },
      meta: {requiresAuth: false, title: 'Согласие на обработку персональных данных / Следограф'},
    },
    {
      path: '/consent/telegram',
      component: LegalDocument,
      props: { doc: 'consentTelegram' },
      meta: {requiresAuth: false, title: 'Согласие на Telegram-уведомления / Следограф'},
    },
    {
      path: '/consent/news',
      component: LegalDocument,
      props: { doc: 'consentNews' },
      meta: {requiresAuth: false, title: 'Согласие на информационную рассылку / Следограф'},
    },
    {
      path: '/signup',
      component: SignUp,
      meta: {requiresAuth: false, title: 'Регистрация / Следограф'},
      name: 'signup',
    },
    {
      path: '/signin',
      component: SignIn,
      meta: {requiresAuth: false, title: 'Вход / Следограф'},
      name: 'signin',
    },
    {
      path: '/404',
      component: PageNotFound,
      meta: {requiresAuth: false, title: '404 / Следограф'},
      name: 'page-not-found',
    },
    {
      path: '/restore-password',
      component: RestorePassword,
      meta: {requiresAuth: false, title: 'Восстановление пароля / Следограф'},
      name: 'restore-password',
    },
    {
      path: '/confirm/:token',
      component: EmailConfirm,
      meta: {requiresAuth: false, title: 'Подтверждение почты / Следограф'},
      name: 'confirm',
    },
    {
      path: '/verify-email/:token',
      component: EmailConfirm,
      meta: {requiresAuth: false, title: 'Подтверждение почты / Следограф'},
      name: 'verify-email',
    },
    {
      path: '/reset-password/:token',
      component: CreateNewPassword,
      meta: {requiresAuth: false, title: 'Изменение пароля / Следограф'},
      name: 'reset-password',
    },
    {
      path: '/health',
      component: Health,
      meta: { requiresAuth: false, title: 'Health Check' },
      name: 'health',
    },
    {
      path: '/access-denied',
      component: AccessDenied,
      meta: {requiresAuth: false, title: 'Доступ запрещен / Следограф'},
      name: 'access-denied',
    },
    {
      path: '/user-registered',
      component: UserRegistered,
      meta: {requiresAuth: false, title: 'Успешная регистрация / Следограф'},
      name: 'user-registered',
    },
    {
      path: '/password-changed',
      component: PasswordChanged,
      meta: {requiresAuth: false, title: 'Пароль изменён / Следограф'},
      name: 'password-changed',
    },
    {
      path: '/dashboard',
      component: Dashboard,
      meta: {requiresAuth: true, title: 'Статистика / Следограф'},
      name: 'dashboard',
    },
    {
      path: '/signout',
      component: SignOut,
      meta: {requiresAuth: false},  // Allow access even when logged out (during logout process)
      name: 'signout',
    },
    {
      path: '/create-project',
      component: ProjectForm,
      meta: {requiresAuth: true, title: 'Создание проекта / Следограф'},
      name: 'createProject',
    },
    {
      path: '/project/:projectId',
      props: true,
      component: ProjectForm,
      meta: {requiresAuth: true, title: 'Редактирование проекта / Следограф'},
      name: 'editProject',
    },
    {
      path: '/projects',
      component: Projects,
      meta: { requiresAuth: true, title: 'Проекты / Следограф' },
      name: 'projectsList',
    },
    {
      path: '/admin/telegram',
      component: Telegram,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Телеграм / Следограф' 
      },
      name: 'telegramList',
    },
    {
      path: '/admin/dzen',
      component: DzenSources,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Источники Дзен / Следограф'
      },
      name: 'dzenSourcesList',
    },
    {
      path: '/admin/x',
      component: AdminX,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'X.com / Следограф'
      },
      name: 'xSourcesList',
    },
    {
      path: '/admin/websites',
      component: Websites,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Сайты / Следограф'
      },
      name: 'websitesList',
    },
    // Backward compatibility redirect
    {
      path: '/telegram',
      redirect: '/admin/telegram',
      meta: { requiresAuth: true, requiresRoles: ['admin'] }
    },
    {
      path: '/test-roles',
      component: TestRoles,
      meta: { requiresAuth: true, title: 'Тест ролей / Следограф' },
      name: 'testRoles',
    },
    {
      path: '/test-navigation',
      component: TestNavigation,
      meta: { requiresAuth: true, title: 'Тест навигации / Следограф' },
      name: 'testNavigation',
    },
    {
      path: '/test-route-guards',
      component: TestRouteGuards,
      meta: { requiresAuth: true, title: 'Тест Route Guards / Следограф' },
      name: 'testRouteGuards',
    },
    {
      path: '/test-permissions',
      component: TestPermissions,
      meta: { requiresAuth: true, title: 'Тест прав доступа / Следограф' },
      name: 'testPermissions',
    },
    // Admin routes - require admin role
    {
      path: '/admin/users',
      component: UserManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Управление пользователями / Следограф' 
      },
      name: 'userManagement',
    },
    {
      path: '/admin/monitoring',
      component: SystemMonitoring,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Мониторинг системы / Следограф' 
      },
      name: 'systemMonitoring',
    },
    {
      path: '/admin/sources',
      component: SourceConfiguration,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Настройка источников / Следограф' 
      },
      name: 'sourceConfiguration',
    },
    {
      path: '/admin/invitations',
      component: InvitationCodes,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Коды приглашений / Следограф' 
      },
      name: 'invitationCodes',
    },
    {
      path: '/admin/settings',
      component: Settings,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Настройки системы / Следограф' 
      },
      name: 'settings',
    },
    {
      path: '/admin/auth-events',
      component: AuthEvents,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Журнал входов / Следограф'
      },
      name: 'auth-events',
    },
    {
      path: '/admin/notifications',
      component: () => import('@/views/admin/NotificationsEditor.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Уведомления — редактор / Следограф'
      },
    },
    {
      path: '/admin/help',
      component: () => import('@/views/admin/HelpEditor.vue'),
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Справка — редактор / Следограф'
      },
    },
    {
      path: '/admin/teams',
      component: () => import('@/views/admin/TeamsAdmin.vue'),
      meta: { requiresAuth: true, requiresRoles: ['admin'], title: 'Команды / Следограф' },
      name: 'adminTeams',
    },
    {
      path: '/teams',
      component: () => import('@/views/Teams.vue'),
      meta: { requiresAuth: true, title: 'Мои команды / Следограф' },
      name: 'myTeams',
    },
    {
      path: '/admin/plans',
      component: Plans,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Тарифы / Следограф'
      },
      name: 'plans',
    },
    {
      path: '/admin/llm-costs',
      component: LlmCosts,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Расходы LLM / Следограф'
      },
      name: 'llmCosts',
    },
    // Reference data routes - require admin role
    {
      path: '/admin/references',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочники / Следограф'
      },
      name: 'references',
    },
    {
      path: '/admin/references/languages',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочник языков / Следограф' 
      },
      name: 'referenceLanguages',
    },
    {
      path: '/admin/references/platforms',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочник платформ / Следограф' 
      },
      name: 'referencePlatforms',
    },
    {
      path: '/admin/references/media-kinds',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочник типов СМИ / Следограф' 
      },
      name: 'referenceMediaKinds',
    },
    {
      path: '/admin/references/topics',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочник тем / Следограф' 
      },
      name: 'referenceTopics',
    },
    {
      path: '/admin/references/geolocations',
      component: ReferenceManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Справочник географии / Следограф' 
      },
      name: 'referenceGeolocations',
    },
    {
      path: '/admin/authors',
      component: AuthorsManagement,
      meta: { 
        requiresAuth: true, 
        requiresRoles: ['admin'],
        title: 'Авторы / Следограф' 
      },
      name: 'authorsManagement',
    },
    {
      path: '/admin/prompts',
      component: PromptsManagement,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'LLM Промты / Следограф'
      },
      name: 'promptsManagement',
    },
    {
      path: '/admin/social-accounts',
      component: SocialAccounts,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Аккаунты для скрапинга / Следограф'
      },
      name: 'socialAccounts',
    },
    {
      path: '/admin/proxies',
      component: ProxiesManagement,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Управление прокси / Следограф'
      },
      name: 'proxiesManagement',
    },
    {
      path: '/admin/roles',
      component: RolesPermissions,
      meta: {
        requiresAuth: true,
        requiresRoles: ['admin'],
        title: 'Роли и права / Следограф'
      },
      name: 'rolesPermissions',
    },
    // Profile route
    // Справка: только для вошедших пользователей
    {
      path: '/help/:section?',
      component: () => import('@/views/help/Help.vue'),
      props: true,
      meta: {requiresAuth: true, title: 'Справка / Следограф'},
    },
    {
      path: '/profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        title: 'Профиль / Следограф'
      },
      name: 'profile',
    },
    // Monitoring routes
    {
      path: '/monitoring/messages',
      component: Messages,
      meta: {
        requiresAuth: true,
        title: 'Сообщения / Следограф'
      },
      name: 'monitoringMessages',
    },
    {
      path: '/monitoring/entities',
      component: Entities,
      meta: {
        requiresAuth: true,
        title: 'Сущности / Следограф'
      },
      name: 'monitoringEntities',
    },
    {
      path: '/monitoring/reports',
      component: Reports,
      meta: {
        requiresAuth: true,
        title: 'Отчёты / Следограф'
      },
      name: 'monitoringReports',
    },
    {
      path: '/monitoring/my-sources',
      component: MySources,
      meta: {
        requiresAuth: true,
        title: 'Свои источники / Следограф'
      },
      name: 'mySources',
    },
    {
      path: '/monitoring/networks',
      component: Networks,
      meta: {
        requiresAuth: true,
        requiresPermission: 'feature:osint',
        title: 'Сети ТГ каналов / Следограф'
      },
      name: 'networks',
    },
    // Notifications route
    {
      path: '/notifications',
      component: NotificationSettings,
      meta: {
        requiresAuth: true,
        title: 'Уведомления / Следограф'
      },
      name: 'notifications',
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404'
    },
  ]
});


// Wait for auth initialization without the check-then-watch race: if init
// completes between the check and the subscription, store.watch never fires
// (it only reacts to CHANGES) and the guard would hang forever. Re-checking
// after subscribing closes the window. Also kick initializeAuth (idempotent)
// in case the boot dispatch was missed.
function waitForAuthInit() {
  if (store.getters.isAuthInitialized) return Promise.resolve();
  store.dispatch('initializeAuth');
  return new Promise((resolve) => {
    const unwatch = store.watch(
      (state) => state.authInitialized,
      (authInitialized) => {
        if (authInitialized) {
          unwatch();
          resolve();
        }
      }
    );
    if (store.getters.isAuthInitialized) {
      unwatch();
      resolve();
    }
  });
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresRoles = to.meta.requiresRoles;

  document.title = to.meta.title || 'Следограф';

  // Для /signin нужно проверить, залогинен ли пользователь
  if (to.path === '/signin') {
    // Дожидаемся инициализации auth если нужно (без гонки — см. waitForAuthInit)
    await waitForAuthInit();
    // Если залогинен - редирект на dashboard
    if (store.state.isLoggedIn) {
      return next({ path: '/dashboard' });
    }
  }

  // Если маршрут не требует авторизации, просто пропускаем
  if (!requiresAuth) {
    return next();
  }

  // Wait for auth initialization if it hasn't been done yet
  if (!store.getters.isAuthInitialized) {
    console.log('[Router] Waiting for auth initialization...');
    await waitForAuthInit();
    console.log('[Router] Auth initialization complete');
  }

  const isLoggedIn = store.state.isLoggedIn;
  const userRoles = store.getters.userRoles;

  // Если маршрут требует авторизации, но пользователь не залогинен
  if (requiresAuth && !isLoggedIn) {
    console.log('[Router] User not logged in, redirecting to signin');
    return next({ path: '/signin', query: { redirect: to.fullPath } });
  }

  // Право-фича (meta.requiresPermission: 'feature:onion_sources'), админ проходит всегда
  const requiresPermission = to.meta.requiresPermission;
  if (requiresPermission && !store.getters.hasPermission(requiresPermission)) {
    console.log('[Router] User lacks required permission:', requiresPermission);
    return next({ path: '/access-denied' });
  }

  // Check role requirements
  if (requiresRoles && requiresRoles.length > 0) {
    const hasRequiredRole = requiresRoles.some(role => userRoles.includes(role));
    
    if (!hasRequiredRole) {
      console.log('[Router] User lacks required roles:', {
        required: requiresRoles,
        userRoles: userRoles
      });
      // Redirect to access denied page
      return next({ path: '/access-denied' });
    }
  }

  // Во всех остальных случаях
  return next();
});


export default router;

